import moment from 'moment';
import { orderBy } from 'natural-orderby';
import queryString from 'query-string';
import React, { useEffect, useRef, useState } from 'react';
import Modal from 'react-modal';
import { withRouter } from 'react-router-dom';
import Swal from 'sweetalert2';

import viewImage from '../../../assets/images/text-search.png';
import UploadFile from '../../../components/Input/UploadFile';
import AlertService from '../../../components/SweetAlert';
import ToastUtil from '../../../components/ToastNotification/ToastUtil';
import { config } from '../../../config/index';

import {
  changeStartOfWeek,
  toWeekEndDate,
  toWeekInt,
  toWeekStartDate,
  toWeekString,
} from '../../../helpers/moment';

import { GET, POST, newFetch } from '../../../helpers/fetch';

import Searchbar from '../../../components/Searchbar';
import AssociateLeaves from '../../../components/SmartScheduler/AssociateLeaves';
import Associates from '../../../components/SmartScheduler/Associates';
import BrUpload from '../../../components/SmartScheduler/BrUpload';
import Calendar from '../../../components/SmartScheduler/Calendar';
import ScheduleUpload from '../../../components/SmartScheduler/ScheduleUpload';
import Shifts from '../../../components/SmartScheduler/Shifts';
import ManageShiftsSpreadsheetView from '../../../components/SmartScheduler/SpreadsheetView/Shifts';
import SpreadsheetView from '../../../components/SmartScheduler/SpreadsheetView';
import StatusTabs from '../../../components/SmartScheduler/StatusTabs';
import UploadPickRate from '../../../components/SmartScheduler/UploadPickRate';
import UploadTimesheet from '../../../components/SmartScheduler/UploadTimesheet';
import WeekMonthUpload from '../../../components/SmartScheduler/WeekMonthUpload';
import AppContext from '../../../store/App/contexts';

import './styles.css';

const { API_URL } = config;

const SmartScheduler = ({ history, location: { search } }) => {
  const params = queryString.parse(search);
  const token = localStorage.getItem('token');
  const type = localStorage.getItem('type');
  const { selectedClientID, selectedSiteID, siteFilterHandler } =
    React.useContext(AppContext);
  const clientID = parseInt(selectedClientID, 10);
  const siteID = parseInt(selectedSiteID, 10);
  const [spreadsheetView, setSpreadsheetView] = useState(true);
  const [showModalShifts, setShowModalShifts] = useState(false);

  const padding = 90; // adjust this to your needs
  let height = 400 + padding;
  let heightPx = height + 'px';
  let heightOffset = height / 2;
  let offsetPx = heightOffset + 'px';

  const style = {
    border: '0',
    borderRadius: '20px',
    bottom: 'auto',
    height: heightPx, // set height
    left: '50%',
    padding: '2rem',
    position: 'fixed',
    right: 'auto',
    top: '50%', // start from center
    transform: 'translate(-50%,-' + offsetPx + ')', // adjust top "up" based on height
    width: '50%',
    maxWidth: '50rem',
  };

  const statuses =
    type === 'client'
      ? ['Assigned', 'On Time', 'Late', 'Absent', 'Cancelled']
      : [
          'Assigned',
          'Not Assigned',
          'Ack',
          'Not Ack',
          'On Time',
          'Late',
          'Absent',
          'Cancelled',
          'Preferred',
          'Not Available',
        ];

  const [clients, setClients] = useState([]);
  const [sites, setSites] = useState([]);
  const [shifts, setShifts] = useState([]);
  const [activeClient, setActiveClient] = useState(null);
  const [activeSite, setActiveSite] = useState(null);
  const [activeShift, setActiveShift] = useState(null);
  const [activeView, setActiveView] = useState('week');
  const [activeDate, setActiveDate] = useState(moment(params.date));
  const [associates, setAssociates] = useState([]);
  const [siteAssociates, setSiteAssociates] = useState([]);
  const [siteAssociateEmails, setSiteAssociateEmails] = useState([]);
  const [siteAssociateLeaves, setSiteAssociateLeaves] = useState([]);
  const [activeStatus, setActiveStatus] = useState(
    params.status ? params.status : 'Assigned'
  );
  const [selectedDate, setSelectedDate] = useState(
    params.spreadsheetViewDate ||
      `${new Date().getMonth() + 1}-${new Date().getFullYear()}`
  );
  const clickOnceRef = useRef(false);

  const [activeAssociates, setActiveAssociates] = useState([]);
  const [filteredActiveAssociates, setFilteredActiveAssociates] = useState([]);
  const [activeTabAssociates, setActiveTabAssociates] = useState([]);

  const [schedules, setSchedules] = useState([]);
  const [activeSchedules, setActiveSchedules] = useState([]);
  const [sidebarMultiAssocLeaves, setSidebarMultiAssocLeaves] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [showAdditionalModal, setShowAdditionalModal] = useState(false);
  const [showShiftSlotModal, setShowShiftSlotModal] = useState(false);
  const [template] = useState(true);

  const [gettingData, setGettingData] = useState(true);
  const [refreshCalendar, setRefreshCalendar] = useState(true);
  const [calendarAttendance, setCalendarAttendance] = useState([]);
  const [selectedShiftForUpdateSlot, setSelectedShiftForUpdateSlot] = useState(
    []
  );
  const [newShiftSlot, setNewShiftSlot] = useState([]);

  // calendar states
  const [activeWeek, setActiveWeek] = useState({});
  const [modalResponseError, setModalResponseError] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const [loading, setLoading] = useState(true);
  const allSitesSelected = siteID === 0 && sites.length > 1;
  const availableSiteIds = sites.map((site) => site.id);
  const availableSiteIdsKey = availableSiteIds.join(',');
  const spreadsheetSite = React.useMemo(
    () =>
      allSitesSelected
        ? {
            id: 0,
            client_id: activeClient?.id,
            name: 'All',
            enable_dl_monthly_reports: sites.some(
              (site) => site.enable_dl_monthly_reports
            ),
            enable_preferred_schedule: sites.some(
              (site) => site.enable_preferred_schedule
            ),
          }
        : activeSite,
    [allSitesSelected, activeClient?.id, activeSite, availableSiteIdsKey]
  );
  const activeShiftSite = allSitesSelected
    ? sites.find(
        (site) =>
          Number(site.id) ===
          Number(
            shifts.find((shift) => Number(shift.id) === Number(activeShift))
              ?.site_id
          )
      ) || null
    : activeSite;
  const handleOpenModal = () => {
    setModalResponseError('');
    setShowModal(true);
  };
  const handleCloseModal = () => setShowModal(false);

  const handleOpenAdditionalModal = () => setShowAdditionalModal(true);
  const handleCloseAdditionalModal = () => setShowAdditionalModal(false);
  const handleCloseShiftSlotModal = () => setShowShiftSlotModal(false);
  const [assocCheckedItems, setAssocCheckedItems] = useState([]);

  const activeViewHandler = (type) => setActiveView(type);

  const updateAllSitesDate = (date) => {
    if (!date || !moment(date).isValid()) return;

    const formattedDate = moment(date).format('YYYY-MM-DD');
    setActiveDate(formattedDate);
    history.push({
      pathname: '/smart-scheduler',
      search: queryString.stringify({
        ...params,
        client: activeClient.id,
        site: 0,
        date: formattedDate,
      }),
    });
  };

  const searchHandler = (e) => {
    setSearchValue(e.target.value);

    let filteredAbsent = [...activeAssociates.absent].filter((associate) => {
      let name = `${associate.first_name} ${associate.last_name}`;
      return name.toUpperCase().indexOf(e.target.value.toUpperCase()) > -1;
    });

    let filteredAssigned = [...activeAssociates.assigned].filter(
      (associate) => {
        let name = `${associate.first_name} ${associate.last_name}`;
        return name.toUpperCase().indexOf(e.target.value.toUpperCase()) > -1;
      }
    );

    let filteredNotAssigned = [...activeAssociates.notAssigned].filter(
      (associate) => {
        let name = `${associate.first_name} ${associate.last_name}`;
        return name.toUpperCase().indexOf(e.target.value.toUpperCase()) > -1;
      }
    );

    let filteredAcknowledged = [...activeAssociates.acknowledged].filter(
      (associate) => {
        let name = `${associate.first_name} ${associate.last_name}`;
        return name.toUpperCase().indexOf(e.target.value.toUpperCase()) > -1;
      }
    );

    let filteredNotAcknowledged = [...activeAssociates.notAcknowledged].filter(
      (associate) => {
        let name = `${associate.first_name} ${associate.last_name}`;
        return name.toUpperCase().indexOf(e.target.value.toUpperCase()) > -1;
      }
    );

    let filteredOnTime = [...activeAssociates.onTime].filter((associate) => {
      let name = `${associate.first_name} ${associate.last_name}`;
      return name.toUpperCase().indexOf(e.target.value.toUpperCase()) > -1;
    });

    let filteredCancelled = [...activeAssociates.cancelled].filter(
      (associate) => {
        let name = `${associate.first_name} ${associate.last_name}`;
        return name.toUpperCase().indexOf(e.target.value.toUpperCase()) > -1;
      }
    );

    let filteredExtension = [...activeAssociates.extension].filter(
      (associate) => {
        let name = `${associate.first_name} ${associate.last_name}`;
        return name.toUpperCase().indexOf(e.target.value.toUpperCase()) > -1;
      }
    );

    let filteredLate = [...activeAssociates.late].filter((associate) => {
      let name = `${associate.first_name} ${associate.last_name}`;
      return name.toUpperCase().indexOf(e.target.value.toUpperCase()) > -1;
    });

    let filteredVTO = [...activeAssociates.vto].filter((associate) => {
      let name = `${associate.first_name} ${associate.last_name}`;
      return name.toUpperCase().indexOf(e.target.value.toUpperCase()) > -1;
    });

    let filteredPreferred = [...activeAssociates.preferred].filter(
      (associate) => {
        let name = `${associate.first_name} ${associate.last_name}`;
        return name.toUpperCase().indexOf(e.target.value.toUpperCase()) > -1;
      }
    );

    let filteredNotAvailable = [...activeAssociates.notAvailable].filter(
      (associate) => {
        let name = `${associate.first_name} ${associate.last_name}`;
        return name.toUpperCase().indexOf(e.target.value.toUpperCase()) > -1;
      }
    );

    let filteredAnnualLeave = [...activeAssociates.annualLeave].filter(
      (associate) => {
        let name = `${associate.first_name} ${associate.last_name}`;
        return name.toUpperCase().indexOf(e.target.value.toUpperCase()) > -1;
      }
    );

    let filteredEmergencyLeave = [...activeAssociates.emergencyLeave].filter(
      (associate) => {
        let name = `${associate.first_name} ${associate.last_name}`;
        return name.toUpperCase().indexOf(e.target.value.toUpperCase()) > -1;
      }
    );

    let filteredMedicalLeave = [...activeAssociates.medicalLeave].filter(
      (associate) => {
        let name = `${associate.first_name} ${associate.last_name}`;
        return name.toUpperCase().indexOf(e.target.value.toUpperCase()) > -1;
      }
    );

    let filteredUnpaidLeave = [...activeAssociates.unpaidLeave].filter(
      (associate) => {
        let name = `${associate.first_name} ${associate.last_name}`;
        return name.toUpperCase().indexOf(e.target.value.toUpperCase()) > -1;
      }
    );

    let filteredChildCareLeave = [...activeAssociates.childCareLeave].filter(
      (associate) => {
        let name = `${associate.first_name} ${associate.last_name}`;
        return name.toUpperCase().indexOf(e.target.value.toUpperCase()) > -1;
      }
    );

    let filteredHospitalLeave = [...activeAssociates.hospitalLeave].filter(
      (associate) => {
        let name = `${associate.first_name} ${associate.last_name}`;
        return name.toUpperCase().indexOf(e.target.value.toUpperCase()) > -1;
      }
    );

    let filteredOnLeave = [...activeAssociates.onLeave].filter((associate) => {
      let name = `${associate.first_name} ${associate.last_name}`;
      return name.toUpperCase().indexOf(e.target.value.toUpperCase()) > -1;
    });

    let filtered = {
      absent: filteredAbsent,
      assigned: filteredAssigned,
      notAssigned: filteredNotAssigned,
      acknowledged: filteredAcknowledged,
      notAcknowledged: filteredNotAcknowledged,
      onTime: filteredOnTime,
      cancelled: filteredCancelled,
      extension: filteredExtension,
      late: filteredLate,
      vto: filteredVTO,
      preferred: filteredPreferred,
      notAvailable: filteredNotAvailable,
      annualLeave: filteredAnnualLeave,
      emergencyLeave: filteredEmergencyLeave,
      medicalLeave: filteredMedicalLeave,
      unpaidLeave: filteredUnpaidLeave,
      childCareLeave: filteredChildCareLeave,
      hospitalLeave: filteredHospitalLeave,
      onLeave: filteredOnLeave,
    };

    setFilteredActiveAssociates(filtered);
  };

  const fetchAssociates = async (activeSite) => {
    if (Array.isArray(activeSite)) {
      const responses = await Promise.all(
        activeSite.map((site) =>
          newFetch(GET, `/site/${site.id}/associates`)
        )
      );
      const associatesById = new Map();

      responses.forEach((response) => {
        if (response.success) {
          response.data.forEach((associate) => {
            if (!associatesById.has(associate.id)) {
              associatesById.set(associate.id, associate);
            }
          });
        }
      });

      setAssociates(Array.from(associatesById.values()));
      return;
    }

    let url = `${API_URL}/site/${activeSite.id}/associates`;
    setLoading(true);
    try {
      let response = await fetch(url, {
        mode: 'cors',
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      let data = await response.json();
      if (response.ok) {
        setAssociates(data.data);
      } else {
        console.log('Failed to fetch employees');
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchClients = async (id) => {
    let api_path = `/client`;
    let response = await newFetch(GET, api_path);
    let clientStartDay;
    let clientsData;

    if (response.success) {
      if (id) {
        clientsData = orderBy(
          response.data.filter(
            (client) =>
              client.enable_smart_scheduler === true && client.id == id
          ),
          [(client) => client.name]
        );
      } else {
        clientsData = orderBy(
          response.data.filter(
            (client) => client.enable_smart_scheduler === true
          ),
          [(client) => client.name]
        );
      }

      setClients(response.data);

      if (type === 'admin') {
        clientStartDay = clientsData[0]?.start_day ?? 0;
      } else {
        clientStartDay =
          clientsData.find((client) => client.id === parseInt(params.client))
            ?.start_day ?? 0;
      }

      changeStartOfWeek(clientStartDay);

      if (clientsData.length > 0) {
        const selectedClient =
          clientID &&
          clientsData.find((client) => client.id === parseInt(clientID))
            ? clientsData.find((client) => client.id === parseInt(clientID))
            : clientsData[0];
        setActiveClient({ ...selectedClient, enable_reward: false });
      } else {
        setActiveClient(null);
      }
    }
  };

  const fetchClientSites = async (client_id) => {
    let api_path = `/client/${client_id}/site?accessible_only=1`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      let sitesOrder = orderBy(response.data, [(site) => site.name]);
      let sitesData = sitesOrder.filter((site) => site.active);
      if (sitesData.length <= 0) {
        setSites([]);
        setActiveSite(null);
        setAssociates([]);
        setSiteAssociates([]);
        setSchedules([]);
        setShifts([]);
        setGettingData(false);
        setLoading(false);
        Swal.close();
        return true;
      }

      await setSites(sitesData);

      const allSitesSelected = siteID === 0 && sitesData.length > 1;

      if (allSitesSelected) {
        setActiveSite(null);
        setSiteAssociates([]);
        setSchedules([]);
        setShifts([]);
        setGettingData(false);
        setLoading(false);
        Swal.close();
        await fetchAssociates(sitesData);

        if (params.date == null) {
          params.date = moment(activeDate).format('YYYY-MM-DD');
        }

        await history.push({
          pathname: `/smart-scheduler`,
          search: queryString.stringify({
            ...params,
            client: client_id,
            site: 0,
          }),
        });
        return true;
      }

      const requestedSiteID =
        Number(params.site) > 0 ? parseInt(params.site) : siteID;
      const active =
        sitesData.find((site) => site.id === requestedSiteID) || sitesData[0];

      await setActiveSite(active);

      if (siteID !== active.id) {
        localStorage.setItem('site', active.id);
        siteFilterHandler(active.id);
      }

      if (params.date == null) {
        params.date = moment(activeDate).format('YYYY-MM-DD');
      }

      await history.push({
        pathname: `/smart-scheduler`,
        search: queryString.stringify({
          ...params,
          client: client_id,
          site: active.id,
        }),
      });
    }
  };

  const fetchShifts = async (site_id) => {
    setGettingData(true);

    if (Number(site_id) === 0) {
      const responses = await Promise.all(
        sites.map((site) => newFetch(GET, `/site/${site.id}/shifts`))
      );
      const shiftsData = responses.flatMap((response, index) =>
        response.success
          ? response.data.map((shift) => ({
              ...shift,
              site_id: shift.site_id || sites[index].id,
              site_name: sites[index].name,
            }))
          : []
      );

      setShifts(shiftsData);
      setGettingData(false);
      return;
    }

    let api_path = `/site/${site_id}/shifts`;
    let response = await newFetch(GET, api_path);
    if (response.success) {
      let shiftsData = response.data;

      if (shiftsData.length > 0) {
        setShifts(shiftsData);
        // setActiveShift(
        //   params.shift ? parseInt(params.shift) : shiftsData.filter((shift) => shift.status == true).sort((a, b) => a.sort - b.sort)[0].id
        // );

        // if (!params.shift) {
        //   history.push({
        //         pathname: '/smart-scheduler',
        //         search: queryString.stringify({
        //           ...params,
        //           shift: shiftsData.filter((shift) => shift.status == true).sort((a, b) => a.sort - b.sort)[0].id,
        //         }),
        //       });
        // }
      } else {
        clientID != 0 &&
          activeClient == null &&
          ToastUtil.error('No shifts assign for this site.');
        setShifts([]);
        setActiveShift(null);
      }
    }
  };

  const fetchAssociateFiledLeaves = async () => {
    let api_path = `/leave/associate/details`;
    let response = await newFetch(POST, api_path, {
      emails: siteAssociateEmails,
      start_date: moment(activeWeek.startDate).format('YYYY-MM-DD'),
      date_flag: 'Weekly',
    });
    if (response.success) {
      setSiteAssociateLeaves(response.data);
    } else {
      setSiteAssociateLeaves([]);
    }
  };

  const fetchSchedules = async (site_id) => {
    if (!activeWeek.startDate || !activeWeek.endDate) return;

    newTriggerForloading();
    setGettingData(true);
    setActiveSchedules([]);
    let api_path = `/site/${site_id}/schedule`;
    let response = await newFetch(POST, api_path, {
      client_id: activeClient?.id || clientID,
      site_ids: site_id === 0 ? sites.map((site) => site.id) : [site_id],
      start_date: moment(activeWeek.startDate).format('YYYY-MM-DD'),
      end_date: moment(activeWeek.endDate).format('YYYY-MM-DD'),
    });

    if (response.success && activeClient) {
      let schedulesData = response.data;

      if (site_id === 0) {
        setSchedules(schedulesData);
        setGettingData(false);
        Swal.close();
        return;
      }

      if (!activeSite) {
        setGettingData(false);
        Swal.close();
        return;
      }

      const currentWeekStartDate = toWeekStartDate(
        moment(),
        activeClient.start_day
      );

      //create site schedule
      if (
        //activeSite.enable_br_upload === false &&
        moment(activeWeek.startDate).isSameOrAfter(moment(currentWeekStartDate))
      ) {
        if (schedulesData.length == 0) {
          clickOnceRef.current = true;
          const api_path = `/site/${site_id}/schedule/create`;
          const resp = await newFetch(POST, api_path, {
            start_date: moment(activeWeek.startDate).format('YYYY-MM-DD'),
            end_date: moment(activeWeek.endDate).format('YYYY-MM-DD'),
            activeDate,
          });

          if (resp.success) {
            schedulesData = resp.scheduleArr;
          }
        }
      }
      setSchedules(schedulesData);
    } else if (site_id === 0) {
      setSchedules([]);
    }

    setGettingData(false);
    Swal.close();
  };

  const fetchScheduleAssociates = async (
    setSiteId,
    scheduleData,
    selectedShiftId
  ) => {
    setGettingData(true);
    let shiftId = selectedShiftId || activeShift;
    let associates_by_status = {
      absent: [],
      acknowledged: [],
      assigned: [],
      cancelled: [],
      extension: [],
      late: [],
      notAcknowledged: [],
      notAssigned: [],
      notAvailable: [],
      onTime: [],
      preferred: [],
      vto: [],
      annualLeave: [],
      emergencyLeave: [],
      medicalLeave: [],
      unpaidLeave: [],
      childCareLeave: [],
      hospitalLeave: [],
      onLeave: [],
    };

    let schedule_preference_api_path = `/site/${setSiteId}/preference`;
    let schedule_preference_response = await newFetch(
      POST,
      schedule_preference_api_path,
      {
        start_date: moment(activeDate).format('YYYY-MM-DD'),
        end_date: moment(activeDate).format('YYYY-MM-DD'),
      }
    );

    let associates_preference = schedule_preference_response.data;

    associates_by_status.preferred = associates_preference
      .filter(
        (preference) =>
          preference.shift_id === shiftId && preference.is_available === true
      )
      .map((preference) => preference.associate)
      .map((associate) => ({
        ...associate,
        is_fixed: 0,
        is_team_support: 0,
      }));

    associates_by_status.notAvailable = associates_preference
      .filter(
        (preference) =>
          preference.shift_id === shiftId && preference.is_available === false
      )
      .map((preference) => preference.associate)
      .map((associate) => ({
        ...associate,
        is_fixed: 0,
        is_team_support: 0,
      }));

    if (scheduleData.length > 0) {
      const shiftSchedule = scheduleData.find(
        (schedule) => schedule.shift_id === shiftId
      );

      if (shiftSchedule) {
        const scheduleId = shiftSchedule.id;

        let associate_preference_api_path = `/schedule/${scheduleId}/reminders`;
        let associate_preference_response = await newFetch(
          GET,
          associate_preference_api_path
        );

        if (associate_preference_response.success) {
          let associate_preference = associate_preference_response.data;
          let notifications = associate_preference
            ? associate_preference.notifications
            : [];

          if (notifications && notifications.length > 0) {
            const mapAck = new Map();
            notifications
              .filter((notification) => notification.is_acknowledged)
              .forEach((item) => {
                if (!mapAck.has(item.associate_id)) {
                  mapAck.set(item.associate_id, { ...item });
                }
              });

            const mergedAckData = Array.from(mapAck.values());

            associates_by_status.acknowledged = mergedAckData
              .filter((notification) => notification.is_acknowledged)
              .map((notification) => notification.associate)
              .map((associate) => ({
                ...associate,
                is_fixed: associate.site_associates.find(
                  (site) => site.site_id === setSiteId
                )?.is_team_support
                  ? 1
                  : 0,
                is_team_support: associate.site_associates.find(
                  (site) => site.site_id === setSiteId
                )?.is_team_support
                  ? 1
                  : 0,
              }));

            const mapNotAck = new Map();
            notifications
              .filter((notification) => !notification.is_acknowledged)
              .forEach((item) => {
                if (!mapNotAck.has(item.associate_id)) {
                  mapNotAck.set(item.associate_id, { ...item });
                }
              });

            const mergedNotAckData = Array.from(mapNotAck.values());

            associates_by_status.notAcknowledged = mergedNotAckData
              .filter((notification) => !notification.is_acknowledged)
              .map((notification) => notification.associate)
              .map((associate) => ({
                ...associate,
                is_fixed: associate.site_associates.find(
                  (site) => site.site_id === setSiteId
                )?.is_team_support
                  ? 1
                  : 0,
                is_team_support: associate.site_associates.find(
                  (site) => site.site_id === setSiteId
                )?.is_team_support
                  ? 1
                  : 0,
              }));
          }
        }
      }
    }

    if (scheduleData.length > 0) {
      const shiftSchedule = scheduleData.find(
        (schedule) => schedule.shift_id === shiftId
      );

      if (shiftSchedule) {
        const scheduleId = shiftSchedule.id;

        let schedule_associates_api_path = `/schedule/${scheduleId}/associates`;
        let schedule_associates_response = await newFetch(
          GET,
          schedule_associates_api_path
        );

        associates_by_status = {
          ...associates_by_status,
          ...schedule_associates_response.data,
        };

        let assigned = [...associates_by_status.assigned].filter(
          (associate) => associate.status === 1
        );

        let onTime = associates_by_status.assigned.filter(
          (associate) => associate.status === 2
        );

        associates_by_status = {
          ...associates_by_status,
          notAssigned:
            type === 'client' ? [] : associates_by_status.notAssigned,
          assigned,
          onTime,
        };
      }
    }

    setActiveAssociates(associates_by_status);
    setFilteredActiveAssociates(
      JSON.parse(JSON.stringify(associates_by_status))
    );
    setAssocCheckedItems([]);
    setRefreshCalendar(false);
    setGettingData(false);
  };

  useEffect(() => {
    params.date && setActiveDate(params.date);
  }, [params]);

  // change active week
  useEffect(() => {
    if (activeClient && activeDate) {
      setActiveWeek({
        startDate: toWeekStartDate(moment(activeDate), activeClient.start_day),
        endDate: toWeekEndDate(moment(activeDate), activeClient.start_day),
      });
    }
  }, [activeDate, activeClient]);

  // change schedule
  useEffect(() => {
    if (
      typeof activeDate === 'string' &&
      /^\d{4}-\d{2}-\d{2}$/.test(activeDate) && // Matches YYYY-MM-DD
      !isNaN(new Date(activeDate).getTime()) &&
      activeSite
    ) {
      fetchSchedules(activeSite.id);
      fetchShifts(activeSite.id);
    }
  }, [activeDate, activeSite]);

  useEffect(() => {
    if (
      allSitesSelected &&
      activeClient &&
      activeWeek.startDate &&
      activeWeek.endDate
    ) {
      fetchSchedules(0);
      fetchShifts(0);
    }
  }, [
    allSitesSelected,
    activeClient,
    activeWeek.startDate,
    activeWeek.endDate,
    availableSiteIdsKey,
  ]);

  useEffect(() => {
    const associateSiteId = activeSite?.id || shifts.find(
      (shift) => Number(shift.id) === Number(activeShift)
    )?.site_id;

    if (associateSiteId && associates) {
      let filtered = associates
        .filter((associate) =>
          associate.sites.find((site) => site.id === associateSiteId)
        )
        .map((associate) => ({
          active: associate.active,
          createdAt: associate.createdAt,
          date_of_birth: associate.date_of_birth,
          deletedAt: associate.deletedAt,
          email: associate.email,
          employee_id: associate.employee_id,
          employee_no: associate.employee_no,
          first_name: associate.first_name,
          id: associate.id,
          image: associate.image,
          is_fixed: associate.sites.find((site) => site.id === associateSiteId)
            .is_team_support,
          is_team_support: associate.sites.find(
            (site) => site.id === associateSiteId
          ).is_team_support,
          last_name: associate.last_name,
          push_token: associate.push_token,
          status: 6,
          updatedAt: associate.updatedAt,
        }));

      setSiteAssociates(filtered);

      let filteredAssociateEmails = associates
        .filter((associate) =>
          associate.sites.find((site) => site.id === associateSiteId)
        )
        .map((associate) => ({
          email: associate.email,
        }));

      setSiteAssociateEmails(filteredAssociateEmails);
    } else {
      setSiteAssociates([]);
      setSiteAssociateEmails([]);
    }
  }, [associates, activeSite, activeShift, shifts]);

  useEffect(() => {
    if (siteAssociateEmails.length > 0) {
      fetchAssociateFiledLeaves();
    }
  }, [siteAssociateEmails, activeWeek]);

  // change active shifts
  // useEffect(() => {
  //   if (activeSite) fetchShifts(activeSite.id);
  // }, [activeSite]);

  // change active schedules
  useEffect(() => {
    let active_schedule = schedules.filter(
      (schedule) => schedule.date === moment(params.date).format('YYYY-MM-DD')
    );

    if (shifts.length > 0 && (activeSite || allSitesSelected)) {
      const defaultShiftId = shifts
        .filter((shifts) =>
          moment(activeWeek.startDate).isSameOrAfter(
            toWeekStartDate(moment(), activeClient?.start_day).add(7, 'days')
          )
            ? shifts.status == true
            : active_schedule.some(
                (siteSchedule) => shifts.id === siteSchedule.shift_id
              )
        )
        .sort((a, b) => a.sort - b.sort)[0]?.id;

      const requestedShiftId = params.shift ? parseInt(params.shift) : null;
      const selectedShiftId = shifts.some(
        (shift) => Number(shift.id) === Number(requestedShiftId)
      )
        ? requestedShiftId
        : defaultShiftId;
      const selectedShiftSiteId = activeSite?.id || shifts.find(
        (shift) => Number(shift.id) === Number(selectedShiftId)
      )?.site_id;

      setActiveShift(selectedShiftId);

      if (selectedShiftSiteId && selectedShiftId) {
        fetchScheduleAssociates(
          selectedShiftSiteId,
          active_schedule,
          selectedShiftId
        );
      }
      setActiveSchedules(active_schedule);
    } else {
      setActiveSchedules([]);
      setActiveAssociates({
        absent: [],
        acknowledged: [],
        assigned: [],
        cancelled: [],
        extension: [],
        late: [],
        notAcknowledged: [],
        notAssigned: [],
        notAvailable: [],
        onTime: [],
        preferred: [],
        vto: [],
        annualLeave: [],
        emergencyLeave: [],
        medicalLeave: [],
        unpaidLeave: [],
        childCareLeave: [],
        hospitalLeave: [],
        onLeave: [],
      });
      setFilteredActiveAssociates(
        JSON.parse(
          JSON.stringify({
            absent: [],
            acknowledged: [],
            assigned: [],
            cancelled: [],
            extension: [],
            late: [],
            notAcknowledged: [],
            notAssigned: [],
            notAvailable: [],
            onTime: [],
            preferred: [],
            vto: [],
            annualLeave: [],
            emergencyLeave: [],
            medicalLeave: [],
            unpaidLeave: [],
            childCareLeave: [],
            hospitalLeave: [],
            onLeave: [],
          })
        )
      );
    }
  }, [schedules, shifts, activeSite, allSitesSelected]);

  // change active tab associates
  useEffect(() => {
    activeStatus === 'Assigned'
      ? setActiveTabAssociates(filteredActiveAssociates.assigned)
      : activeStatus === 'Not Assigned'
      ? setActiveTabAssociates(filteredActiveAssociates.notAssigned)
      : activeStatus === 'Ack'
      ? setActiveTabAssociates(filteredActiveAssociates.acknowledged)
      : activeStatus === 'Not Ack'
      ? setActiveTabAssociates(filteredActiveAssociates.notAcknowledged)
      : activeStatus === 'On Time'
      ? setActiveTabAssociates(filteredActiveAssociates.onTime)
      : activeStatus === 'Late'
      ? setActiveTabAssociates(filteredActiveAssociates.late)
      : activeStatus === 'Absent'
      ? setActiveTabAssociates(filteredActiveAssociates.absent)
      : activeStatus === 'Cancelled'
      ? setActiveTabAssociates(filteredActiveAssociates.cancelled)
      : activeStatus === 'Preferred'
      ? setActiveTabAssociates(filteredActiveAssociates.preferred)
      : activeStatus === 'Not Available'
      ? setActiveTabAssociates(filteredActiveAssociates.notAvailable)
      : activeStatus === 'AL'
      ? setActiveTabAssociates(filteredActiveAssociates.annualLeave)
      : activeStatus === 'EL'
      ? setActiveTabAssociates(filteredActiveAssociates.emergencyLeave)
      : activeStatus === 'ML'
      ? setActiveTabAssociates(filteredActiveAssociates.medicalLeave)
      : activeStatus === 'UL'
      ? setActiveTabAssociates(filteredActiveAssociates.unpaidLeave)
      : activeStatus === 'CCL'
      ? setActiveTabAssociates(filteredActiveAssociates.childCareLeave)
      : activeStatus === 'HL'
      ? setActiveTabAssociates(filteredActiveAssociates.hospitalLeave)
      : setActiveTabAssociates([]);
  }, [filteredActiveAssociates, activeStatus]);

  useEffect(() => {
    fetchClients(clientID);
  }, [clientID, siteID]);

  useEffect(() => {
    if (activeSite != null) {
      fetchAssociates(activeSite);
    }
  }, [activeSite]);

  useEffect(() => {
    if (activeClient) fetchClientSites(activeClient.id);
  }, [activeClient]);

  const [todayFillRate, setTodayFillRate] = useState({
    percentage: 0,
    filled: 0,
    total: 0,
  });

  const [fillRates, setFillRates] = useState(null);
  const [todayAttendanceRate, setTodayAttendanceRate] = useState(null);
  const [attendanceRates, setAttendanceRates] = useState(null);

  useEffect(() => {
    const setFilLRatesArr = async (attendanceArr) => {
      let totalFilled = 0;
      let totalSlots = 0;

      for (let schedule of activeSchedules) {
        let scheduleAttendance = attendanceArr.find(
          (scheduleAttendance) => scheduleAttendance.schedule_id === schedule.id
        );
        let isFixed = [
          ...scheduleAttendance.assigned,
          ...scheduleAttendance.late,
          ...scheduleAttendance.absent,
        ].filter((associate) => associate.is_fixed).length;

        let actualFilledSlots = schedule.filled_slots + isFixed;
        let actualTotalSlots = schedule.slots.slots + isFixed;

        totalFilled += actualFilledSlots;
        totalSlots += actualTotalSlots;
      }

      let percentage = Math.round((totalFilled / totalSlots) * 100);

      if (percentage) {
        setTodayFillRate({
          percentage: isNaN(percentage) ? 0 : percentage,
          filled: totalFilled,
          total: totalSlots,
        });
      }

      let fillRatesArr = [];

      for (let shift of shifts) {
        let schedule = activeSchedules.find(
          (schedule) => schedule.shift_id === shift.id
        );

        if (schedule) {
          let attendance = attendanceArr.find(
            (scheduleAttendance) =>
              scheduleAttendance.schedule_id === schedule.id
          );

          let isFixedCount = attendance
            ? [
                ...attendance.assigned,
                ...attendance.late,
                ...attendance.absent,
              ].filter((associate) => associate.is_fixed).length
            : 0;

          let overwriteSchedule = {
            ...shift,
            schedule: schedule
              ? {
                  ...schedule,
                  filled_slots: schedule.filled_slots + isFixedCount,
                  slots: {
                    ...schedule.slots,
                    slots: schedule.slots.slots,
                  },
                }
              : null,
          };

          fillRatesArr.push(overwriteSchedule);
        } else {
          fillRatesArr.push({
            ...shift,
            schedule: null,
          });
        }
      }

      setFillRates(fillRatesArr);
    };

    const setAttendanceRatesArr = async (attendanceArr) => {
      if (attendanceArr.length > 0) {
        // count attendance for each shift
        let attendanceArrTotal = attendanceArr.map((attendance) => ({
          shift_id: activeSchedules.find(
            (schedule) => schedule.id === attendance.schedule_id
          ).shift_id,
          schedule_id: attendance.schedule_id,
          attended:
            attendance.assigned.length +
            // + attendance.extension.filter(associate => !associate.is_fixed).length
            attendance.late.filter(
              (associate) => associate.status === 3 || associate.status === 4
            ).length,
          total: activeSchedules.find(
            (schedule) => schedule.id === attendance.schedule_id
          ).slots.slots,
        }));

        let attendancePercentage = attendanceArrTotal.map((attendance) => ({
          shift_id: attendance.shift_id,
          schedule_id: attendance.schedule_id,
          attended: attendance.attended,
          total: attendance.total,
          rate: isNaN((attendance.attended / attendance.total) * 100)
            ? 0
            : (attendance.attended / attendance.total) * 100,
        }));

        setAttendanceRates(attendancePercentage);
      }
    };

    const runAsyncFunctions = async () => {
      if (activeSchedules.length > 0) {
        const attendanceArrResponse = await Promise.all(
          activeSchedules.map(
            async (schedule) =>
              await newFetch(GET, `/schedule/${schedule.id}/associates`)
          )
        );

        const attendanceArr = attendanceArrResponse.map((res) => res.data);

        await setFilLRatesArr(attendanceArr);
        await setAttendanceRatesArr(attendanceArr);
        await setCalendarAttendance(attendanceArr);
      } else {
        setFillRates(shifts.map((shift) => ({ ...shift, schedule: null })));
        setTodayFillRate({ percentage: 0, filled: 0, total: 0 });
        setAttendanceRates(null);
        setTodayAttendanceRate({
          attended: 0,
          total: 0,
          rate: 0,
        });
      }
    };

    if (activeSchedules.length > 0) {
      let timer = setTimeout(() => runAsyncFunctions(), 200);
      return () => {
        clearTimeout(timer);
      };
    } else {
      setFillRates(null);
      setTodayFillRate(null);
      setAttendanceRates(null);
      setTodayAttendanceRate({
        attended: 0,
        total: 0,
        rate: 0,
      });
    }
  }, [activeSchedules]);

  useEffect(() => {
    let attended = 0;
    let total = 0;

    if (attendanceRates) {
      attendanceRates.map((attendance) => {
        attended += attendance.attended;
        total += attendance.total;
      });

      setTodayAttendanceRate({
        attended: attended,
        total: total,
        rate: isNaN((attended / total) * 100) ? 0 : (attended / total) * 100,
      });
    } else {
      setTodayAttendanceRate({
        attended: 0,
        total: 0,
        rate: 0,
      });
    }
  }, [attendanceRates]);

  useEffect(() => {
    setSearchValue('');
  }, [activeDate, activeSchedules, activeShift]);

  const isNumeric = (value) => {
    return /^-?\d+$/.test(value);
  };

  const saveNewShiftSlot = async () => {
    if (!isNumeric(newShiftSlot) || JSON.parse(newShiftSlot) < 0) {
      ToastUtil.error('Invalid slot number.');
      return false;
    } else {
      if (
        await AlertService.confirm('', 'Do you really want to save a new slot?')
      ) {
        let api_path = `/site/${activeSite.id}/schedule/slots`;
        let response = await newFetch(POST, api_path, {
          slots: newShiftSlot,
          site_schedule_id: selectedShiftForUpdateSlot[0].id,
        });

        if (response.success) {
          setShowShiftSlotModal(false);
          ToastUtil.success('Save new slot successfully.');
          window.location.reload();
        } else {
          ToastUtil.error(
            'Saving new slot not successful, Please contact the admin.'
          );
        }
      }
    }
  };

  // render
  let modal = '';
  let additionalModal = '';
  let shiftSlotModal = '';

  const [requiredHours, setRequiredHours] = useState(44);

  if (activeClient && activeSite) {
    modal = (
      <Modal
        ariaHideApp={false}
        isOpen={showModal}
        style={{
          overlay: { backgroundColor: 'rgba(0, 0, 0, 0.5)' },
          content: style,
        }}
        onAfterOpen={() => (document.body.style.overflow = 'hidden')}
        onAfterClose={() => (document.body.style.overflow = 'auto')}
      >
        {activeWeek.startDate && activeWeek.endDate && (
          <React.Fragment>
            <h5>
              Upload Required Schedule for Week{' '}
              {toWeekInt(activeWeek.startDate, activeClient.start_day)},{' '}
              {toWeekString(activeWeek.endDate, activeClient.start_day)}
            </h5>
            {modalResponseError && (
              <div>
                <label
                  style={{
                    color: '#f83232',
                    paddingTop: 11,
                    fontWeight: 700,
                  }}
                >
                  Results:
                </label>
                <p className="mb-4 ms-2" style={{ color: '#f84949' }}>
                  {modalResponseError}
                </p>
              </div>
            )}
            <div className="mb-2">
              <label htmlFor="requiredHours">No. of hours this week</label>
              <input
                id="requiredHours"
                type="number"
                className="form-control text-end"
                value={requiredHours}
                onChange={(e) => setRequiredHours(e.target.value)}
              />
            </div>
            <p className="text-muted">Drag and drop your file here</p>

            <UploadFile
              url={`${API_URL}/site/${activeSite.id}/schedule/upload/required`}
              otherData={{ hours: requiredHours }}
              handleCloseModal={handleCloseModal}
              template={'templates/br_upload_template.csv'}
              setModalResponseError={setModalResponseError}
            />
          </React.Fragment>
        )}
      </Modal>
    );

    additionalModal = (
      <Modal
        ariaHideApp={false}
        isOpen={showAdditionalModal}
        style={{
          overlay: { backgroundColor: 'rgba(0, 0, 0, 0.5)' },
          content: style,
        }}
      >
        {activeWeek.startDate && activeWeek.endDate && (
          <React.Fragment>
            <h5>
              Upload Additional Schedule for Week{' '}
              {toWeekInt(activeWeek.startDate, activeClient.start_day)},{' '}
              {toWeekString(activeWeek.endDate, activeClient.start_day)}
            </h5>
            {modalResponseError && (
              <div>
                <label
                  style={{
                    color: '#f83232',
                    paddingTop: 11,
                    fontWeight: 700,
                  }}
                >
                  Results:
                </label>
                <p className="mb-4 ms-2" style={{ color: '#f84949' }}>
                  {modalResponseError}
                </p>
              </div>
            )}
            <p className="text-muted">Drag and drop your file here</p>

            <UploadFile
              url={`${API_URL}/site/${activeSite.id}/schedule/upload/additional`}
              handleCloseModal={handleCloseAdditionalModal}
              template={'templates/br_upload_template.xlsx'}
              setModalResponseError={setModalResponseError}
            />
          </React.Fragment>
        )}
      </Modal>
    );

    shiftSlotModal = (
      <Modal
        ariaHideApp={false}
        isOpen={showShiftSlotModal}
        style={{
          overlay: { backgroundColor: 'rgba(0, 0, 0, 0.5)' },
          content: { ...style, height: '310px', padding: '3rem' },
        }}
      >
        {activeWeek.startDate &&
          activeWeek.endDate &&
          selectedShiftForUpdateSlot.length > 0 && (
            <React.Fragment>
              <h5>Update Slots</h5>
              <div className="row">
                <div className="col-lg-3">
                  <label className="pe-2">Shift Date:</label>
                </div>
                <p className="text-muted col-lg-9">
                  {selectedShiftForUpdateSlot[0].date}
                </p>
              </div>

              <div className="row">
                <div className="col-lg-3">
                  <label className="pe-2">Shift Date:</label>
                </div>
                <p className="text-muted col-lg-9">
                  {selectedShiftForUpdateSlot[0].shift.name}{' '}
                  {selectedShiftForUpdateSlot[0].shift.start_time} -{' '}
                  {selectedShiftForUpdateSlot[0].shift.end_time}
                </p>
              </div>

              <div className="row">
                <div className="col-lg-3">
                  <label className="pe-2">Headcount:</label>
                </div>
                <input
                  type="number"
                  min="0"
                  className="form-control col-lg-2 ms-3"
                  id="assigneSlot"
                  defaultValue={selectedShiftForUpdateSlot[0].slots.slots}
                  onChange={(e) => {
                    setNewShiftSlot(e.target.value);
                  }}
                />
              </div>

              <div
                className="row d-flex justify-content-end mt-10 pt-3 align-items"
                style={{
                  marginTop: 10,
                }}
              >
                <button
                  type="submit"
                  className="btn btn-brand ms-3"
                  style={{ width: '12rem', marginRight: 10 }}
                  onClick={() => {
                    saveNewShiftSlot();
                  }}
                >
                  Save
                </button>
                <button
                  type="button"
                  onClick={() => {
                    handleCloseShiftSlotModal();
                  }}
                  className="btn btn-outline-brand"
                  style={{ width: '12rem' }}
                >
                  Cancel
                </button>
              </div>
            </React.Fragment>
          )}
      </Modal>
    );
  }

  const newTriggerForloading = () =>
    Swal.fire({
      title: 'Loading, please wait...',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
      customClass: {
        title: 'swal-title-custom',
      },
    });

  useEffect(() => {
    shifts.length > 0 && setRefreshCalendar(false);
  }, [shifts]);

  const allSitesWeekDates =
    activeWeek.startDate && activeWeek.endDate
      ? Array.from({ length: 7 }, (_, index) =>
          moment(activeWeek.startDate).add(index, 'days')
        )
      : [];

  return (
    <div
      className="container-fluid"
      style={{
        paddingLeft: '2rem',
        paddingRight: '2rem',
        paddingBottom: '6rem',
      }}
    >
      <div className="border-bottom pb-2 py-4 d-flex align-items-center">
        <h6 className="flex-grow-1 module-title">Smart Scheduler</h6>
      </div>
      {clientID == 0 && (
        <div className="text-muted pt-4">
          Please select client and site to continue.
        </div>
      )}

      {clientID != 0 && activeClient == null && (
        <div className="text-muted pt-4">
          The client does not have access to this module.
        </div>
      )}
      {clientID != 0 &&
        activeClient &&
        allSitesSelected &&
        !spreadsheetView &&
        activeSite && (
        <div className="pt-4">
          <div className="d-flex flex-wrap align-items-end justify-content-between gap-3 pb-4">
            <div>
              <h6 className="mb-1">All Site Schedules</h6>
              <div className="text-muted small">
                {activeWeek.startDate && activeWeek.endDate
                  ? `${moment(activeWeek.startDate).format(
                      'DD MMM YYYY'
                    )} - ${moment(activeWeek.endDate).format('DD MMM YYYY')}`
                  : ''}
              </div>
            </div>
            <div className="d-flex align-items-end gap-2">
              <div className="btn-group" role="group" aria-label="Change week">
                <button
                  type="button"
                  className="btn btn-light border"
                  title="Previous week"
                  onClick={() =>
                    updateAllSitesDate(
                      moment(activeWeek.startDate).subtract(7, 'days')
                    )
                  }
                >
                  <i className="fas fa-chevron-left" />
                </button>
                <button
                  type="button"
                  className="btn btn-light border"
                  title="Current week"
                  onClick={() => updateAllSitesDate(moment())}
                >
                  <i className="far fa-circle" />
                </button>
                <button
                  type="button"
                  className="btn btn-light border"
                  title="Next week"
                  disabled={
                    type === 'client' &&
                    moment(activeWeek.endDate).isAfter(moment())
                  }
                  onClick={() =>
                    updateAllSitesDate(
                      moment(activeWeek.startDate).add(7, 'days')
                    )
                  }
                >
                  <i className="fas fa-chevron-right" />
                </button>
              </div>
              <div>
                <label
                  className="form-label small mb-1"
                  htmlFor="allSitesDate"
                >
                  Week containing
                </label>
                <input
                  id="allSitesDate"
                  type="date"
                  className="form-control form-control-sm"
                  value={
                    moment(activeDate).isValid()
                      ? moment(activeDate).format('YYYY-MM-DD')
                      : ''
                  }
                  onChange={(event) => updateAllSitesDate(event.target.value)}
                />
              </div>
              <Shifts
                activeDate={activeDate}
                activeClient={activeClient}
                activeSite={null}
                activeWeek={activeWeek}
                fetchSchedules={fetchSchedules}
                sites={sites}
                selectedSiteID={siteID}
                manageOnly
              />
            </div>
          </div>
          {sites.map((site) => {
            const siteSchedules = schedules.filter(
              (schedule) => Number(schedule.site_id) === Number(site.id)
            );
            const siteShifts = Array.from(
              siteSchedules.reduce((shiftMap, schedule) => {
                if (schedule.shift) {
                  shiftMap.set(schedule.shift_id, schedule.shift);
                }
                return shiftMap;
              }, new Map())
            )
              .map(([id, shift]) => ({ id, ...shift }))
              .sort(
                (a, b) =>
                  Number(a.sort || 0) - Number(b.sort || 0) ||
                  String(a.name || '').localeCompare(String(b.name || ''))
              );
            const totalSlots = siteSchedules.reduce(
              (total, schedule) =>
                total + Number(schedule.slots?.slots || 0),
              0
            );
            const filledSlots = siteSchedules.reduce(
              (total, schedule) =>
                total + Number(schedule.filled_slots || 0),
              0
            );

            return (
              <section
                key={site.id}
                className="border-bottom pb-4 mb-4"
                aria-labelledby={`all-site-${site.id}`}
              >
                <div className="d-flex align-items-center justify-content-between pb-2">
                  <div>
                    <h6 id={`all-site-${site.id}`} className="mb-1">
                      {site.name}
                    </h6>
                    <div className="text-muted small">
                      {siteSchedules.length} schedules, {filledSlots} of{' '}
                      {totalSlots} slots filled
                    </div>
                  </div>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-brand"
                    title={`Open ${site.name}`}
                    onClick={() => {
                      localStorage.setItem('site', site.id);
                      siteFilterHandler(site.id);
                      history.push({
                        pathname: '/smart-scheduler',
                        search: queryString.stringify({
                          ...params,
                          client: activeClient.id,
                          site: site.id,
                        }),
                      });
                    }}
                  >
                    Open site <i className="fas fa-arrow-right ms-1" />
                  </button>
                </div>
                <div className="table-responsive border">
                  <table
                    className="table table-bordered align-middle mb-0"
                    style={{ minWidth: 1050, tableLayout: 'fixed' }}
                  >
                    <thead className="table-light">
                      <tr>
                        <th style={{ width: 210 }}>Shift</th>
                        {allSitesWeekDates.map((date) => (
                          <th key={date.format('YYYY-MM-DD')}>
                            <div>{date.format('ddd')}</div>
                            <div className="small fw-normal text-muted">
                              {date.format('DD MMM')}
                            </div>
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {siteShifts.map((shift) => (
                        <tr key={shift.id}>
                          <th scope="row">
                            <div>{shift.name || '-'}</div>
                            <div className="small fw-normal text-muted">
                              {moment(shift.start_time, 'HH:mm:ss').format(
                                'hh:mm A'
                              )}{' '}
                              -{' '}
                              {moment(shift.end_time, 'HH:mm:ss').format(
                                'hh:mm A'
                              )}
                            </div>
                          </th>
                          {allSitesWeekDates.map((date) => {
                            const schedule = siteSchedules.find(
                              (item) =>
                                Number(item.shift_id) === Number(shift.id) &&
                                item.date === date.format('YYYY-MM-DD')
                            );
                            const scheduleSlots = Number(
                              schedule?.slots?.slots || 0
                            );
                            const scheduleFilled = Number(
                              schedule?.filled_slots || 0
                            );

                            return (
                              <td key={date.format('YYYY-MM-DD')}>
                                {schedule ? (
                                  <div>
                                    <div className="fw-medium">
                                      {scheduleFilled} / {scheduleSlots}
                                    </div>
                                    <div className="small text-muted">
                                      {Math.max(
                                        scheduleSlots - scheduleFilled,
                                        0
                                      )}{' '}
                                      available
                                    </div>
                                  </div>
                                ) : (
                                  <span className="text-muted">-</span>
                                )}
                              </td>
                            );
                          })}
                        </tr>
                      ))}
                      {!gettingData && siteShifts.length === 0 && (
                        <tr>
                          <td
                            className="text-center text-muted py-4"
                            colSpan={allSitesWeekDates.length + 1}
                          >
                            No schedules found for this week.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </section>
            );
          })}
        </div>
      )}
      {activeClient && (activeSite || allSitesSelected) && (
        <div className="row align-items-center">
          <div className="col-6">
            {activeClient !== null && spreadsheetSite !== null && (
                <WeekMonthUpload
                  showModal={handleOpenModal}
                  showAdditionalModal={handleOpenAdditionalModal}
                  activeView={activeView}
                  toggleView={activeViewHandler}
                  activeWeek={activeWeek}
                  activeSite={spreadsheetSite}
                  sites={sites}
                  activeClient={activeClient}
                  activeDate={params.spreadsheetViewDate}
                  siteAssociates={
                    allSitesSelected ? associates : siteAssociates
                  }
                  selectedDate={selectedDate}
                />
              )}
          </div>
          <div className="col-6 text-end pe-4">
            <img
              src={viewImage} // put your PNG path here
              alt="Clickable PNG"
              style={{
                cursor: 'pointer',
                width: '24px',
                marginRight: 9,
                marginTop: -15,
              }}
              onClick={() => setSpreadsheetView(!spreadsheetView)}
            />
          </div>
        </div>
      )}

      <div
        className="mt-4"
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          marginLeft: '0.5rem',
        }}
      >
        {activeSite?.enable_pick_rate &&
          activeView === 'week' &&
          type !== 'client' &&
          activeClient &&
          activeWeek &&
          activeSite && (
            <UploadPickRate
              activeDate={activeDate}
              activeWeek={activeWeek}
              activeClient={activeClient}
              activeSite={activeSite}
              schedules={schedules}
            />
          )}

        {activeClient && activeSite?.enable_br_upload && (
          <BrUpload
            showModal={handleOpenModal}
            showAdditionalModal={handleOpenAdditionalModal}
            activeView={activeView}
            toggleView={activeViewHandler}
            activeWeek={activeWeek}
            activeClient={activeClient}
            activeSite={activeSite}
          />
        )}

        {activeSite?.enable_upload_timesheet && (
          <UploadTimesheet
            activeView={activeView}
            activeWeek={activeWeek}
            activeClient={activeClient}
            activeSite={activeSite}
          />
        )}

        {activeSite?.enable_schedule_upload && (
          <ScheduleUpload
            activeDate={activeDate}
            activeWeek={activeWeek}
            activeClient={activeClient}
            activeSite={activeSite}
            schedules={schedules}
          />
        )}
      </div>

      {!spreadsheetView && spreadsheetSite && (
        <>
          {activeDate &&
            activeClient &&
            spreadsheetSite &&
            activeWeek.startDate &&
            !refreshCalendar &&
            activeWeek.endDate && (
              <Calendar
                schedules={schedules}
                showModal={showModal}
                handleCloseModal={handleCloseModal}
                activeView={activeView}
                activeSchedules={activeSchedules}
                activeDate={activeDate}
                activeWeek={activeWeek}
                calendarAttendance={calendarAttendance}
                setActiveWeek={setActiveWeek}
                setActiveDate={setActiveDate}
                activeSite={spreadsheetSite}
                activeClient={[...clients].find(
                  (client) => client.id === activeClient.id
                )}
                shifts={shifts}
                todayAttendanceRate={todayAttendanceRate}
                attendanceRates={attendanceRates}
                todayFillRate={todayFillRate}
                fillRates={fillRates}
                setRefreshCalendar={setRefreshCalendar}
                clickOnceRef={clickOnceRef}
                siteAssociateLeaves={siteAssociateLeaves}
                setSidebarMultiAssocLeaves={setSidebarMultiAssocLeaves}
                setLoading={setLoading}
                sites={sites}
                selectedSiteID={siteID}
              />
            )}

          {activeView === 'week' && activeClient && (
            <React.Fragment>
              {activeDate &&
                activeClient &&
                activeWeek.startDate &&
                activeWeek.endDate && (
                  <Shifts
                    activeDate={activeDate}
                    activeClient={activeClient}
                    activeSite={spreadsheetSite}
                    activeShifts={shifts}
                    activeShift={activeShift}
                    setActiveShift={setActiveShift}
                    fetchShifts={fetchShifts}
                    fetchSchedules={fetchSchedules}
                    activeWeek={activeWeek}
                    activeSchedules={activeSchedules}
                    setRefreshCalendar={setRefreshCalendar}
                    setAssocCheckedItems={setAssocCheckedItems}
                    rewardReasons={[]}
                    todayAttendanceRate={todayAttendanceRate}
                    attendanceRates={attendanceRates}
                    activeWeekRate={toWeekInt(
                      activeWeek.startDate,
                      activeClient.start_day
                    )}
                    setShowShiftSlotModal={setShowShiftSlotModal}
                    setSelectedShiftForUpdateSlot={
                      setSelectedShiftForUpdateSlot
                    }
                    setNewShiftSlot={setNewShiftSlot}
                    currentWeek={toWeekInt(moment(), '')}
                    todayFillRate={todayFillRate}
                    fillRates={fillRates}
                    fetchScheduleAssociates={fetchScheduleAssociates}
                    sites={sites}
                    selectedSiteID={siteID}
                  />
                )}
              <div className="adjust-assign-associate">
                <Searchbar
                  placeholder="Search employees"
                  width="100%"
                  searchValue={searchValue}
                  search={searchHandler}
                />
                <StatusTabs
                  activeAssociates={filteredActiveAssociates}
                  statuses={statuses}
                  activeStatus={activeStatus}
                  setActiveStatus={setActiveStatus}
                  setAssocCheckedItems={setAssocCheckedItems}
                  activeSite={activeShiftSite || spreadsheetSite}
                />
                <div className="adjust-associate">
                  <Associates
                    sites={sites}
                    activeShift={activeShift}
                    activeDate={activeDate}
                    activeSchedules={activeSchedules}
                    activeWeek={activeWeek}
                    activeClient={activeClient}
                    activeSite={activeShiftSite}
                    associates={activeTabAssociates ? activeTabAssociates : []}
                    fetchSchedules={fetchSchedules}
                    gettingData={gettingData}
                    activeShifts={shifts}
                    assocCheckedItems={assocCheckedItems}
                    setAssocCheckedItems={setAssocCheckedItems}
                    activeStatus={activeStatus}
                    siteAssociateLeaves={siteAssociateLeaves}
                    sidebarMultiAssocLeaves={sidebarMultiAssocLeaves}
                    setSidebarMultiAssocLeaves={setSidebarMultiAssocLeaves}
                  />
                </div>
              </div>
              {modal}
              {additionalModal}
              {shiftSlotModal}
            </React.Fragment>
          )}
        </>
      )}
      {activeClient && spreadsheetSite && spreadsheetView && (
        <React.Fragment>
          {activeDate && activeWeek.startDate && activeWeek.endDate && (
            <ManageShiftsSpreadsheetView
              activeDate={activeDate}
              activeClient={activeClient}
              activeSite={spreadsheetSite}
              activeShifts={shifts}
              activeShift={activeShift}
              setActiveShift={setActiveShift}
              fetchShifts={fetchShifts}
              fetchSchedules={fetchSchedules}
              activeWeek={activeWeek}
              activeSchedules={activeSchedules}
              setRefreshCalendar={setRefreshCalendar}
              setAssocCheckedItems={setAssocCheckedItems}
              rewardReasons={[]}
              todayAttendanceRate={todayAttendanceRate}
              attendanceRates={attendanceRates}
              activeWeekRate={toWeekInt(
                activeWeek.startDate,
                activeClient.start_day
              )}
              setShowShiftSlotModal={setShowShiftSlotModal}
              setSelectedShiftForUpdateSlot={setSelectedShiftForUpdateSlot}
              setNewShiftSlot={setNewShiftSlot}
              currentWeek={toWeekInt(moment(), '')}
              todayFillRate={todayFillRate}
              fillRates={fillRates}
              fetchScheduleAssociates={fetchScheduleAssociates}
              setShowModalShifts={setShowModalShifts}
              showModalShifts={showModalShifts}
              sites={sites}
              selectedSiteID={siteID}
            />
          )}
          <SpreadsheetView
            activeSite={spreadsheetSite}
            siteAssociateList={associates}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            setShowModalShifts={setShowModalShifts}
            showModalShifts={showModalShifts}
            sites={sites}
            selectedSiteID={siteID}
            clientID={activeClient.id}
          />
        </React.Fragment>
      )}
    </div>
  );
};

export default withRouter(SmartScheduler);
